import { render, staticRenderFns } from "./SoftwareAccount.vue?vue&type=template&id=3624dc19&scoped=true&"
import script from "./SoftwareAccount.vue?vue&type=script&lang=ts&"
export * from "./SoftwareAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624dc19",
  null
  
)

export default component.exports